var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41699 19.25C5.91283 19.25 5.48123 19.0705 5.1222 18.7115C4.76317 18.3524 4.58366 17.9208 4.58366 17.4167V5.5H3.66699V3.66667H8.25033V2.75H13.7503V3.66667H18.3337V5.5H17.417V17.4167C17.417 17.9208 17.2375 18.3524 16.8785 18.7115C16.5194 19.0705 16.0878 19.25 15.5837 19.25H6.41699ZM15.5837 5.5H6.41699V17.4167H15.5837V5.5ZM8.25033 15.5833H10.0837V7.33333H8.25033V15.5833ZM11.917 15.5833H13.7503V7.33333H11.917V15.5833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashWhite);
export default __webpack_public_path__ + "static/media/trash_white.e132a6714e20e17bea6003deb040d1b5.svg";
export { ForwardRef as ReactComponent };